(function () {

    'use strict';

    angular.module('app').controller('AccountingHistoricalBillingNotifModalController', AccountingHistoricalBillingNotifModalController);

    AccountingHistoricalBillingNotifModalController.$inject = [
        'toastr',
        'shipment',
        'invoiceId',
        'invoiceData',
        'AccountingService',
        'Units',
        '$uibModal'
    ];

    function AccountingHistoricalBillingNotifModalController(
        toastr,
        shipment,
        invoiceId,
        invoiceData,
        AccountingService,
        Units,
        $uibModal
    ) {

        const vm = this;
        vm.isTooltipEnabled = false;
        vm.shipment = shipment;
        vm.invoiceId = invoiceId;
        vm.invoiceData = invoiceData;
        vm.notifPanelOptions = {
            showViewButton: false
        }

        init();
        
        function init(){
            addWeightUnit();
        }

        function addWeightUnit(){
            vm.shipment.invoiceIssue.map(data=>{
                const tmpData = data;
                if(tmpData.invoiceIssueDetail.weightUnit) {
                    tmpData.invoiceIssueDetail.weightUnit = Units.getWeightUnit(tmpData.invoiceIssueDetail.weightUnit);
                }
                return tmpData;
            });
        }
    }
})();



// WEBPACK FOOTER //
// ./js/controllers/accounting/AccountingHistoricalBillingNotifModalController.js